import React from 'react';
import '../style.css'; // 如果你有全局 style.css 可以改引入那个，保持风格一致

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        © 2025 Hanyang Huang. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;